module.exports = __webpack_public_path__ + "img/home-act.81174ccd.png";